import { genericGetCallRequest } from 'utils/request';
import FileSaver from 'file-saver';
import { uploadToBucketCall } from 'redux-core/images/services';
import { updateDialog } from 'redux-core/dialogs/actions';
import { getDialogByNameSelector, getDialogIndexByNameSelector } from 'redux-core/dialogs/selectors';
import { DRAWERS } from 'components/common/Drawers/constants';
import { getTemplateFileUrlCall, getTracksImportUploadAccessCall } from './services';

const allowedImageTypes = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

const getContentType = (fileName, kind) => {
  if (Object.values(allowedImageTypes).includes(kind) || kind === 'IMAGE') {
    const ext = fileName.split('.').pop();
    const type = allowedImageTypes[ext] || `image/${ext}`;
    return type;
  }

  return 'binary/octet-stream';
};

export const setResolverFinishingOnDialog = (finishing) => (dispatch, getState) => {
  const state = getState();
  const index = getDialogIndexByNameSelector(state, DRAWERS.IMPORT_TRACKS_SPREADSHEET);
  if (index < 0) return;
  const dialog = getDialogByNameSelector(state, DRAWERS.IMPORT_TRACKS_SPREADSHEET);
  dispatch(
    updateDialog({
      index,
      drawer: { ...dialog, payload: { ...dialog.payload, finishing } },
    }),
  );
};

export const setResolverStepOnDialog = () => (dispatch, getState) => {
  const state = getState();
  const index = getDialogIndexByNameSelector(state, DRAWERS.IMPORT_TRACKS_SPREADSHEET);
  if (index < 0) return;
  const dialog = getDialogByNameSelector(state, DRAWERS.IMPORT_TRACKS_SPREADSHEET);
  dispatch(
    updateDialog({
      index,
      drawer: { ...dialog, payload: { ...dialog.payload, step: 'resolve' } },
    }),
  );
};

export const getTemplateFile = () => async () => {
  const url = await getTemplateFileUrlCall();
  const blob = await genericGetCallRequest({
    url,
    responseType: 'blob',
  });
  FileSaver.saveAs(blob, 'tracks_import_template.xlsx');
  return true;
};

export const uploadTracksImportFileCall = async (file, { kind }) => {
  const fileName = file.name || file.fileName;
  const contentType = getContentType(fileName, kind);

  const { key, uploadUrl } = await getTracksImportUploadAccessCall({
    kind,
    contentType,
  });

  await uploadToBucketCall(uploadUrl, { file, contentType });
  return key;
};
